<template>
  <div class="forum_post" @click="onCardClick">
    <div class="forum_post__user">
      <div class="forum_post__avatar_wrap">
        <div class="forum_post__avatar" :style="{ backgroundImage: `url(${data.avatar || FORUM_DEFAULT_AVATAR})` }" />
        <div v-if="frameUrl" class="forum_post__frame" :style="{ backgroundImage: `url(${frameUrl})` }" />
      </div>
      <div class="forum_post__user_info">
        <div class="forum_post__name_row">
          <span class="forum_post__name text_ellipsis">{{ data.nickname || '昵称为空' }}</span>
          <span v-if="nameplate" class="forum_post__nameplate" :style="{ backgroundImage: `url(${nameplate})` }" />
        </div>
        <p v-if="data.timeDesc" class="forum_post__time">{{ data.timeDesc }}</p>
      </div>
    </div>

    <p v-if="data.title" class="forum_post__title">
      <span v-if="data.topStatus === 1" class="forum_post__tag forum_post__tag--top" :style="data.topColor ? { background: data.topColor } : undefined">置顶</span>
      <template v-if="!isTopCard">
        <span v-if="data.essence === 1" class="forum_post__tag forum_post__tag--essence">精华</span>
        <span v-for="tag in data.postTagVos || []" :key="tag.tagName" class="forum_post__tag" :style="{ background: tag.backgroundImage || tag.colour || '#d09962' }">{{ tag.tagName }}</span>
      </template>
      <span class="forum_post__title_text">{{ data.title }}</span>
    </p>

    <div v-if="!isTopCard && contentText" class="forum_post__content">{{ contentText }}</div>

    <div v-if="!isTopCard && previewMedia.length" class="forum_post__img_list">
      <div
        v-for="(media, index) in previewMedia"
        :key="media.detailId || index"
        class="forum_post__img"
        :style="getForumMediaBackgroundStyle(media)"
      >
        <div v-if="media.videoUrl" class="forum_post__video_mask">
          <van-icon name="play-circle-o" class="forum_post__video_icon" />
        </div>
      </div>
    </div>

    <div v-if="!isTopCard" class="forum_post__action">
      <button type="button" class="forum_post__action_btn" @click.stop="$emit('collect', data)">
        <van-icon :name="data.collect ? 'star' : 'star-o'" class="forum_post__action_icon" :color="data.collect ? '#ff7352' : '#c2c2c2'" />
        <p :class="['forum_post__action_count', { 'forum_post__action_count--active': data.collect }]">{{ data.collectNum || 0 }}</p>
      </button>

      <button type="button" class="forum_post__action_btn" @click.stop="onComment">
        <van-icon name="comment-o" class="forum_post__action_icon" color="#c2c2c2" />
        <p class="forum_post__action_count">{{ data.commentNum || 0 }}</p>
      </button>

      <button type="button" class="forum_post__action_btn" @click.stop="$emit('praise', data)">
        <van-icon :name="data.praise ? 'good-job' : 'good-job-o'" class="forum_post__action_icon" :color="data.praise ? '#ff7352' : '#c2c2c2'" />
        <p :class="['forum_post__action_count', { 'forum_post__action_count--active': data.praise }]">{{ data.praiseNum || 0 }}</p>
      </button>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant';
import { stripHtml, truncateText } from '@/utils/forum/format';
import { FORUM_DEFAULT_AVATAR } from '../constants';
import { getForumMediaBackgroundStyle } from '@/utils/forum/media';
import { saveForumPostSnapshot } from '@/utils/forum/postSnapshotCache';

export default {
  name: 'ForumPostItem',
  components: { [Icon.name]: Icon },
  props: {
    data: {
      type: Object,
      required: true,
    },
    disableNavigate: Boolean,
    isTopCard: Boolean,
  },
  data() {
    return {
      FORUM_DEFAULT_AVATAR,
    };
  },
  computed: {
    frameUrl() {
      return (this.data.userLevelFrameInfoVo && this.data.userLevelFrameInfoVo.frameUrl) || '';
    },
    nameplate() {
      return (this.data.userLevelFrameInfoVo && this.data.userLevelFrameInfoVo.nameplate) || '';
    },
    contentText() {
      return truncateText(stripHtml(this.data.content || '').trim(), 50);
    },
    previewMedia() {
      const list = this.data.postsDetailVos || this.data.detailList || [];
      return list.slice(0, 2);
    },
  },
  methods: {
    getForumMediaBackgroundStyle,
    onCardClick() {
      this.$emit('click', this.data);
      if (this.disableNavigate) return;
      this.cachePostSnapshot();
      this.$router.push({ name: 'forum-post-detail', params: { postId: this.data.postsId } });
    },
    onComment() {
      this.$emit('comment', this.data);
      this.cachePostSnapshot();
      this.$router.push({
        name: 'forum-post-detail',
        params: { postId: this.data.postsId },
        query: { focusComment: '1' },
      });
    },
    cachePostSnapshot() {
      const postId = this.data.postsId || this.data.postId;
      if (!postId) return;
      saveForumPostSnapshot(this.data, postId);
    },
  },
};
</script>

<style scoped>
.forum_post {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
  padding: 12px 20px;
  background: #fff;
}

.forum_post:active {
  background: #fafafa;
}

.forum_post__user {
  display: flex;
  align-items: center;
}

.forum_post__avatar_wrap {
  position: relative;
  width: 42px;
  height: 42px;
  margin-right: 10px;
  flex-shrink: 0;
}

.forum_post__avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: #e5e5e5;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.forum_post__frame {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 64px;
  height: 64px;
  pointer-events: none;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  transform: translate(-50%, -50%);
}

.forum_post__user_info {
  min-width: 0;
  flex: 1;
}

.forum_post__name_row {
  display: flex;
  align-items: center;
}

.forum_post__name {
  max-width: 180px;
  color: #333;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
}

.forum_post__nameplate {
  width: 55px;
  height: 25px;
  margin-left: 6px;
  flex-shrink: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.forum_post__time {
  margin: 6px 0 0;
  color: #999;
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
}

.forum_post__title {
  width: 100%;
  margin: 12px 0 0;
  color: #333;
  font-size: 17px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  word-break: break-word;
}

.forum_post__tag {
  position: relative;
  top: -1px;
  display: inline-block;
  height: 16px;
  margin-right: 4px;
  border-radius: 3px;
  padding: 0 6px;
  color: #fbfbfb;
  background: #d09962;
  font-size: 10px;
  line-height: 16px;
  vertical-align: middle;
}

.forum_post__tag--top {
  background: #ff7a00;
}

.forum_post__tag--essence {
  background: #00d0c1;
}

.forum_post__title_text {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  vertical-align: middle;
}

.forum_post__content {
  margin-top: 14px;
  color: #666;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: pre-line;
}

.forum_post__img_list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 12px;
}

.forum_post__img {
  position: relative;
  width: calc((100% - 8px) / 2);
  height: 110px;
  flex: 0 0 calc((100% - 8px) / 2);
  border-radius: 8px;
  overflow: hidden;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.forum_post__img + .forum_post__img {
  margin-left: 8px;
}

.forum_post__video_mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
}

.forum_post__video_icon {
  width: 28px;
  height: 28px;
  color: #fff;
}

.forum_post__action {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 20px;
  margin-top: 20px;
}

.forum_post__action_btn {
  display: flex;
  align-items: center;
  border: 0;
  padding: 0;
  background: transparent;
  line-height: 1;
}

.forum_post__action_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  margin-right: 10px;
  flex-shrink: 0;
  font-size: 17px;
  line-height: 17px;
}

.forum_post__action_count {
  margin: 0;
  color: #c2c2c2;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
}

.forum_post__action_count--active {
  color: #ff7352;
}
</style>
